import { defaultObj } from './state'

// Utilities
import isEmpty from '../../utility/isEmpty'

export default {
  authenticated (state, userData) {
    state.authenticated = true
    state.user = userData.user
    state.username = userData.username

    state.email = userData.email
    state.emailVerified = userData.emailVerified
    state.phone = userData.phone
    state.phoneVerified = userData.phoneVerified

    state.verified = true
    state.showIncompleteAppWarning = true
  },

  unverified (state, userData) {
    state.authenticated = true
    state.user = userData.user
    state.username = userData.username
    state.verified = false
  },

  signout (state) {
    state.authenticated = false
    state.user = null
    state.email = ''
    state.phone = ''
    state.verified = false
  },

  signoutInvictus (state) {
    state.authenticated = false
    state.user = null
    state.verified = false
  },

  setSignOutInProgress (state, value) {
    state.signOutInProgress = value
  },

  setUserData (state, userData) {
    if (userData.hasOwnProperty('username')) {
      state.username = userData.username
    }
    state.password = userData.password
  },

  updateSessionTimeout (state, timeoutData) {
    state.sessionTimeoutStart = timeoutData.timeoutStart
    state.sessionTimeoutIsActive = timeoutData.timeoutIsActive
    state.sessionTimeoutSkip = timeoutData.skipTimeout
  },

  updateServiceStatus (state, statusData = {}) {
    if (!isEmpty(statusData.available)) {
      state.serviceAvailable = statusData.available
    }
  },

  updatePreviousPage (state, previousInfo) {
    if (previousInfo) {
      state.previousPage = previousInfo.previousPage
      state.previousProps = previousInfo.previousProps
    }
  },

  updateConfigSettings (state, data) {
    if (data.manageNotifications !== undefined) {
      state.allowManageNotifications = data.manageNotifications
    }

    if (data.allowNoSsnRefi !== undefined) {
      state.allowNoSsnRefi = data.allowNoSsnRefi
    }

    if (data.allowNlsMlaCheck !== undefined) {
      state.allowNlsMlaCheck = data.allowNlsMlaCheck
    }

    if (data.stickyHeaderId) {
      state.stickyHeaderId = data.stickyHeaderId
    }

    if (data.instaHeaderId) {
      state.instaHeaderId = data.instaHeaderId
    }

    if (data.instaSidebarId) {
      state.instaSidebarId = data.instaSidebarId
    }

    if (data.refiPaymentTimeOut) {
      state.refiPaymentTimeoutLimit = data.refiPaymentTimeOut
    }

    if (data.paymentTimeOut) {
      state.paymentTimeoutLimit = data.paymentTimeOut
    }

    if (data.nlsRefiPaymentTimeOut) {
      state.nlsRefiPaymentTimeoutLimit = data.nlsRefiPaymentTimeOut
    }

    if (data.sessionTimeOut) {
      state.sessionTimeoutLimit = data.sessionTimeOut
    }

    if (data.displayTermsConditionsConsent !== undefined) {
      state.displayTermsConditionsConsent = data.displayTermsConditionsConsent
    }

    if (data.disbursementMaxPollingAttempts !== undefined) {
      state.disbursementMaxPollingAttempts = data.disbursementMaxPollingAttempts
    }

    if (data.trustedDeviceSettings) {
      state.trustedDeviceSettings = data.trustedDeviceSettings
    }

    if (data.loanDocumentUploadSettings) {
      if (data.loanDocumentUploadSettings.LocalFileMimeFilter) {
        state.loanDocUploadFileTypes = data.loanDocumentUploadSettings.LocalFileMimeFilter
      }

      if (data.loanDocumentUploadSettings.InputAcceptFilter) {
        state.loanDocUploadInputTypes = data.loanDocumentUploadSettings.InputAcceptFilter
      }

      if (data.loanDocumentUploadSettings.MaxUploadSizeInMegabytes) {
        state.loanDocUploadMaxSize = data.loanDocumentUploadSettings.MaxUploadSizeInMegabytes
      }
    }

    if (data.pastDuePhoneDayLimit !== undefined) {
      state.pastDuePhoneDayLimit = data.pastDuePhoneDayLimit
    }

    if (data.menuItemVisibility !== undefined) {
      state.menuItemVisibility = data.menuItemVisibility
    }

    if (data.servicesConfig !== undefined) {
      state.servicesConfig = data.servicesConfig
    }

    if (data.c1lPrivacyPolicyUrl) {
      state.c1lPrivacyPolicyUrl = data.c1lPrivacyPolicyUrl
    }

    if (data.cccPrivacyPolicyUrl) {
      state.cccPrivacyPolicyUrl = data.cccPrivacyPolicyUrl
    }

    if (data.ccfPrivacyPolicyUrl) {
      state.ccfPrivacyPolicyUrl = data.ccfPrivacyPolicyUrl
    }

    if (data.chsPrivacyPolicyUrl) {
      state.chsPrivacyPolicyUrl = data.chsPrivacyPolicyUrl
    }

    if (data.cicPrivacyPolicyUrl) {
      state.cicPrivacyPolicyUrl = data.cicPrivacyPolicyUrl
    }

    if (data.esmPrivacyPolicyUrl) {
      state.esmPrivacyPolicyUrl = data.esmPrivacyPolicyUrl
    }

    if (data.inlPrivacyPolicyUrl) {
      state.inlPrivacyPolicyUrl = data.inlPrivacyPolicyUrl
    }

    if (data.tmxPrivacyPolicyUrl) {
      state.tmxPrivacyPolicyUrl = data.tmxPrivacyPolicyUrl
    }

    if (data.deviceDetection !== undefined) {
      state.deviceDetection = data.deviceDetection
    }

    if (data.canUploadNlsLoanDocuments !== undefined) {
      state.canUploadNlsLoanDocuments = data.canUploadNlsLoanDocuments
    }

    if (data.canUploadTlxeLoanDocuments !== undefined) {
      state.canUploadTlxeLoanDocuments = data.canUploadTlxeLoanDocuments
    }

    if (data.canUseCleverTap !== undefined) {
      state.canUseCleverTap = data.canUseCleverTap
    }

    if (data.settlementPaymentRetryLimit !== undefined) {
      state.settlementPaymentRetryLimit = data.settlementPaymentRetryLimit
    }

    if (data.canUseDisbursementPolling !== undefined) {
      state.canUseDisbursementPolling = data.canUseDisbursementPolling
    }

    if (data.displayReferralBalanceHistory !== undefined) {
      state.displayReferralBalanceHistory = data.displayReferralBalanceHistory
    }

    if (data.displayNonCustomerReferral !== undefined) {
      state.displayNonCustomerReferral = data.displayNonCustomerReferral
    }

    if (data.displayRetailReferral !== undefined) {
      state.displayRetailReferral = data.displayRetailReferral
    }

    if (data.outForRepoConfig !== undefined) {
      state.outForRepoConfig = data.outForRepoConfig
    }

    if (data.debtSoldConfig !== undefined) {
      state.debtSoldConfig = data.debtSoldConfig
    }

    if (data.docuSignRedirect !== undefined) {
      state.docuSignRedirect = data.docuSignRedirect
    }

    if (data.checkAddonGps !== undefined) {
      state.checkAddonGps = data.checkAddonGps
    }

    if (data.checkPaymentGps !== undefined) {
      state.checkPaymentGps = data.checkPaymentGps
    }

    if (data.checkRefiGps !== undefined) {
      state.checkRefiGps = data.checkRefiGps
    }

    if (data.forceAddonGps !== undefined) {
      state.forceAddonGps = data.forceAddonGps
    }

    if (data.forcePaymentGps !== undefined) {
      state.forcePaymentGps = data.forcePaymentGps
    }

    if (data.forceRefiGps !== undefined) {
      state.forceRefiGps = data.forceRefiGps
    }

    if (data.canSendVoiceMessages !== undefined) {
      state.canSendVoiceMessages = data.canSendVoiceMessages
    }

    if (data.shareBirdEyeEnabled !== undefined) {
      state.shareBirdEyeEnabled = data.shareBirdEyeEnabled
    }

    if (data.shareTitlemaxEnabled !== undefined) {
      state.shareTitlemaxEnabled = data.shareTitlemaxEnabled
    }

    if (data.restrictManualRetryConfig !== undefined) {
      if (data.restrictManualRetryConfig.enabled !== undefined) {
        state.restrictManualRetry = data.restrictManualRetryConfig.enabled
      }

      if (data.restrictManualRetryConfig.intervalInMinutes !== undefined) {
        state.restrictedRetryTimeInMins = data.restrictManualRetryConfig.intervalInMinutes
      }
    }

    if (data.logNonFatalErrors !== undefined) {
      state.logNonFatalErrors = data.logNonFatalErrors
    }

    if (data.wrongPasswordRedirectCount !== undefined) {
      state.wrongPasswordRedirectCount = data.wrongPasswordRedirectCount
    }

    if (data.bridgePaySettings !== undefined) {
      state.bridgePaySettings = data.bridgePaySettings
    }

    if (data.loanOriginateTimeout) {
      state.loanOriginateTimeout = parseInt(data.loanOriginateTimeout)
    }

    if (data.postDrawTimeout) {
      state.postDrawTimeout = parseInt(data.postDrawTimeout)
    }

    if (data.invictusUrlInfo) {
      state.invictusUrlInfo = data.invictusUrlInfo
    }

    if (data.canEditPhone) {
      state.canEditPhone = data.canEditPhone
    }

    if (data.canEditEmail) {
      state.canEditEmail = data.canEditEmail
    }

    if (data.canEditEmailInvictus) {
      state.canEditEmailInvictus = data.canEditEmailInvictus
    }

    state.savedConfigSettings = true
  },

  hideIncompleteAppWarning (state) {
    state.showIncompleteAppWarning = false
  },

  setInternalRedirect (state, route) {
    state.internalRedirect = route
  },

  clearInternalRedirect (state) {
    state.internalRedirect = defaultObj.internalRedirect
  },

  setForceShowProductSwitchModal (state, data) {
    state.forceShowProductSwitchModal = data
  },

  setForceShowRenewalStatement (state, data) {
    state.forceShowRenewalStatement = data
  },

  setFromLegacyNcr (state, data) {
    state.fromLegacyNcr = data
  },

  setGpsPosition (state, data) {
    if (!isEmpty(data.latitude) && !isEmpty(data.longitude)) {
      state.gpsPosition.latitude = data.latitude
      state.gpsPosition.longitude = data.longitude
    }
  },

  setPasswordPolicy (state, data) {
    if (data.minimumLength !== undefined) {
      state.passwordPolicy.minimumLength = data.minimumLength
    }

    if (data.requireLowercase !== undefined) {
      state.passwordPolicy.requireLowercase = data.requireLowercase
    }

    if (data.requireNoSpaces !== undefined) {
      state.passwordPolicy.requireNoSpaces = data.requireNoSpaces
    }

    if (data.requireNumbers !== undefined) {
      state.passwordPolicy.requireNumbers = data.requireNumbers
    }

    if (data.requireSymbols !== undefined) {
      state.passwordPolicy.requireSymbols = data.requireSymbols
    }

    if (data.requireUppercase !== undefined) {
      state.passwordPolicy.requireUppercase = data.requireUppercase
    }
  },

  saveInvictusSession (state, data) {
    if (!isEmpty(data.email)) {
      state.username = data.email
      state.email = data.email
    }

    if (!isEmpty(data.duplicateEmail)) {
      state.duplicateEmail = data.duplicateEmail
    }

    if (!isEmpty(data.phone)) {
      state.invictusPhone = data.phone
    }

    if (!isEmpty(data.shortFormLoanType)) {
      state.shortFormLoanType = data.shortFormLoanType
    }

    if (!isEmpty(data.salesForceId)) {
      state.salesForceId = data.salesForceId
    }

    if (!isEmpty(data.languageIndicator)) {
      state.languageIndicator = data.languageIndicator
    }

    if (!isEmpty(data.trafficChannel)) {
      state.trafficChannel = data.trafficChannel
    }

    if (!isEmpty(data.invitationCode)) {
      state.invitationCode = data.invitationCode
    }

    if (!isEmpty(data.state)) {
      state.state = data.state
    }

    if (!isEmpty(data.zip)) {
      state.zip = data.zip
    }

    if (!isEmpty(data.firstName)) {
      state.firstName = data.firstName
    }

    if (!isEmpty(data.lastName)) {
      state.lastName = data.lastName
    }

    if (!isEmpty(data.updateInvictusProfile)) {
      state.updateInvictusProfile = data.updateInvictusProfile
    }

    if (!isEmpty(data.redirectUrl)) {
      state.redirectUrl = data.redirectUrl
    }

    if (!isEmpty(data.source)) {
      state.invictusSource = data.source
    }

    state.isInvictus = true
  },

  saveSecurityQuestions (state, data) {
    state.securityQuestions = data
  },

  saveAnsweredSecurityQuestion (state, data) {
    state.answeredSecurityQuestion = data.question
  },

  setNewInvictusCustomer (state, isNew) {
    state.newInvictusCustomer = isNew
  },

  reset (state) {
    state = Object.assign(state, defaultObj)

    if (this.cache.has('session/getServiceStatus') === true) {
      this.cache.delete('session/getServiceStatus')
    }
  }
}
